<mat-form-field appearance="outline">
  <mat-icon matPrefix>search</mat-icon>
  <input
      matInput
      [value]="value"
      [placeholder]="placeholder"
      (input)="onInput($event)">
</mat-form-field>